import React, { useState, useContext } from "react";
import axios from "axios";
import { API_BASE_URL, API_KEY } from "../../../config/config";
import { AuthContext } from "../../../context/authContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../../../assets/customQuillStyles.css';
import Post from "../../Post/Post";
import UserAvatar from "../../common/UserAvatar";
import { ThreadContext } from "../../../context/threadContext";
import qs from "qs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faExpandArrowsAlt, faReply } from "@fortawesome/free-solid-svg-icons";
import { t } from "i18next";

// Define the Quill modules with toolbar options
const modules = {
	toolbar: [
		['bold', 'italic', 'underline', 'strike'],
		['link'],
		['clean']
	]
};

const ReplyForm = ({ thread }) => {
	const { visitor } = useContext(AuthContext);
	const { newReplies, loadMoreNewReplies, bump, threadData } = useContext(ThreadContext);
	const [content, setContent] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState('');

	const handleContentChange = (value) => {
		setContent(value);
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		setIsSubmitting(true);
		setError('');

		if (!content.trim()) {
			setError(t('please_enter_valid_message'));
			setIsSubmitting(false);
			return;
		}

		try {
			let data = qs.stringify({
				'thread_id': thread.thread_id,
				'message': content,
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${API_BASE_URL}/threads/${thread.thread_id}/reply`,
				headers: {
					'XF-Api-Key': API_KEY,
					'XF-Api-User': visitor.user_id,
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: data,
				withCredentials: true
			};

			const response = await axios.request(config);
			let post = response.data.post;

			loadMoreNewReplies(post);

			setContent('');
		} catch (error) {
			console.error('Failed to post reply:', error);
			setError('Failed to post reply. Please try again.');
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div>
			{newReplies && newReplies.length > 0 && (
				<div>
					{newReplies.map((post, index) => (
						<div className="mb-4" key={index}>
							<Post thread={thread} post={post} postId={post.post_id} />
						</div>
					))}
				</div>
			)}

			<div>
				<div className="block-minorHeader">
					Bình luận vào bài viết này
				</div>

				<p className="mt-2 text-sm text-white text-opacity-85">
					Bạn đang bình luận bằng khung bình luận rút gọn.
					Nếu muốn thêm chức năng (đăng ảnh, chỉnh cỡ chữ, .v.v..), vui lòng ấn nút "Mở rộng" phía dưới.
				</p>

				<div className="mt-2 border border-borderColor flex rounded-lg">
					<div className="w-auto flex gap-x-2 bg-primary bg-opacity-85 p-2 flex-shrink-0 flex-grow-0 text-center lg:block lg:w-[160px]">
						<a href={visitor.view_url} title={visitor.username}
						   className="block w-[48px] h-[48px] mb-2 lg:mx-auto lg:w-[96px] lg:h-[96px]">
							<UserAvatar user={visitor} />
						</a>
					</div>

					<div className="flex-1 p-1 min-w-0 lg:p-4">
						<div className="flex flex-col h-full">
							<form onSubmit={handleSubmit} className="reply-form max-w-screen-sm">
								<div className="form-group">
									<ReactQuill
										value={content}
										onChange={handleContentChange}
										placeholder="Viết bình luận"
										modules={modules}
									/>
								</div>

								{error && <p className="mt-2 error text-red-500 font-bold text-sm">{error}</p>}

								<div className="mt-2 flex flex-wrap items-center gap-2">
									<button type="submit" className="flex-1 button bg-secondary lg:flex-grow-0 lg:flex-shrink-0"
									        disabled={isSubmitting}>
										<FontAwesomeIcon icon={faReply} className="mr-2"/>
										{isSubmitting ? 'Loading...' : 'Bình luận'}
									</button>

									<a href={`${thread.view_url}reply`} className="flex-1 button button--cta lg:flex-grow-0 lg:flex-shrink-0">
										<FontAwesomeIcon icon={faExpandArrowsAlt} className="mr-2"/>
										Mở rộng
									</a>

									{thread.can_bump && (
										<span onClick={threadData.bumpMessage === '' ? bump : ''}
										      className={`flex-1 button button--cta ${threadData.bumpMessage !== '' && 'grayscale cursor-not-allowed'} lg:flex-grow-0 lg:flex-shrink-0`}>
											<FontAwesomeIcon icon={faChevronUp} className="mr-2"/>
											Đẩy bài viết (Bump)
										</span>
									)}
								</div>

								{threadData.bumpMessage !== '' && (
									<p className="mt-2 message text-white font-bold text-sm">{threadData.bumpMessage}</p>
								)}
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ReplyForm;